






























import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import FileDrop from '@/components/common/FileDrop.vue';
import FileItem from '@/components/common/FileItem.vue';
import DropZone from '@/components/common/DropZone.vue';
import { API, Storage } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import Modelling from '@/store/modules/Modelling';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import CardTitle from '@/components/common/CardTitle.vue';
import ValueTypes from '@/utils/ValueTypes';

const decisionsModule = getModule(Decisions);
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: { DropZone, FileItem, FileDrop, CardTitle },
})
export default class ImageUploader extends Vue {
    // customized store location in S3 bucket
    @Prop({ default: 'store/', type:String })
    storeUrl!: string;
    // sync property for the access url of the uploaded file
    @PropSync('imgKey', { default: '', type:String })
    internalImgKey!: string
    @PropSync('imgSrc', { default: '', type: String })
    internalImgSrc!: string;

    @Prop({ default: false, type: Boolean})
    base64!: boolean;

    private uploadError = null;
    private uploading = false;
    private uploaded = false;
    private dialog = false;
    private file: any = null;
    private objectKey: string | null = null;
    private uploadProgressPercent: number | null = null;
    private IMAGE_TYPES = ValueTypes.IMAGE_TYPES;
    private increment = 0;

    @Emit('passObjectKey')
    private passObjectKey(objectKey: {key: string, type: string, name: string}) {
        return objectKey;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    private async fileSelected(files: any) {
        // console.log(this.AUDIO_TYPES);
        // console.log(files);
        // console.log('file uploading');
        this.file = files[0];

        if (this.IMAGE_TYPES.findIndex((item: string) => item === this.file.type) !== -1) {
            if (!this.base64) {
                try {
                    this.uploadError = null;
                    this.objectKey = await this.uploadFile(this.file);
                    this.passObjectKey({ key:this.objectKey, type:this.file.type, name:this.file.name});
                    this.internalImgKey = this.objectKey.toString();
                    let resultUrl = await Storage.get(this.objectKey);
                    this.internalImgSrc = resultUrl.toString();
                    this.dialog = false;
                } catch (e) {
                    this.uploadError = e;
                }
            } else {
                if( this.file.size <= 1048576 ) {
                    let reader = new FileReader();
                    reader.readAsDataURL(this.file);
                    reader.onload =  () => {
                        this.internalImgKey = reader.result.toString();
                    };
                    reader.onerror = function (error) {
                        console.log('Error: ', error);
                    };
                    this.dialog = false;
                } else {
                    this.uploadError = 'Image size must smaller than 1MB';
                    setTimeout(() => {
                        this.uploadError = null;
                    }, 2000);
                }
                
            }

        } else {
            this.uploadError = 'Must Upload a Supported Image File';
            setTimeout(() => {
                this.uploadError = null;
            }, 2000);
        }
        this.increment ++;
        // console.log(this.file);
    }



    private async uploadFile(file: any) {
        // console.log(file);
        let name = uuidv4() + '-' + file.name;
        const key: string = `${this.storeUrl}${name}`;
        this.uploading = true;
        let uploadResponse: any = await Storage.put(key, file, {level:'public',
            progressCallback: (progress: any) => {
                this.uploadProgressPercent = progress.loaded / progress.total;
            },
        });

        // console.log(uploadResponse);
        this.uploading = false;
        this.uploaded = true;
        return uploadResponse.key;
    }

    private close() {
        this.dialog = false;
        this.file = null;
    }
}
